import { extend } from 'vee-validate';
import BrandService from '@/services/BrandService';

extend('brand_id_unique', {
  validate: (id) => {
    return BrandService.validateId(id)
      .then((response) => {
        return {
          valid: response.data.isValid,
        };
      })
      .catch(() => {
        return {
          valid: false,
        };
      });
  },
});
